
























































































































































































import { Component } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import TabIndex from "./tabs/TabIndex.vue";
import TabPlanos from "./tabs/TabPlanos.vue";
import TabLimpezaBase from "./tabs/TabLimpezaBase.vue";
import TabAcesso from "./tabs/TabAcesso.vue";
import TabLogAcesso from "./tabs/TabLogAcesso.vue";
import TabAtendimento from "./tabs/TabAtendimento.vue";
import TabEnviosAutomaticos from "./tabs/TabEnviosAutomaticos.vue";
import MensagemErro from "./modals/MensagemErro.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { ConsultoresService, Consultor } from "@/services/consultores.service";
import { cpf } from "@/shared/filters";
import { Lead, LeadService } from "@/services/lead.service";

@Component({
  components: {
    Tooltip,
    TabIndex,
    TabPlanos,
    TabLimpezaBase,
    TabAcesso,
    TabLogAcesso,
    TabAtendimento,
    TabEnviosAutomaticos,
    MensagemErro,
  },
  filters: { cpf },
})
export default class Consultores extends mixins(GlobalMixin) {
  loading = false;
  idConsultor: number | null = null;
  consultor: Consultor | null = null;
  nome: string | null = "";
  tab = "subscribe";
  lead: Lead | null = null;

  mounted() {
    if (this.$route.params.idConsultor) {
      this.idConsultor = +this.$route.params.idConsultor;
      this.fetchConsultoresSelecionado();
    }
  }

  fetchConsultoresSelecionado() {
    ConsultoresService.ObterDadosConsultor(this.idConsultor!).then(
      (consultor) => {
        this.consultor = consultor;
      }
    );

    LeadService.obterPorIdConsultor(this.idConsultor!).then((lead) => {
      this.lead = lead;
    });
  }

  voltar() {
    this.$router.push({
      name: "home",
    });
  }

  async acessarPainel() {
    this.startLoader();
    const acess = await ConsultoresService.AcessarPainel(
      this.idConsultor!
    ).finally(this.stopLoader);
    if (acess.erro) {
      const modal = this.$refs.mensagemErro as MensagemErro;
      await modal.exibirMensagem(acess.urlMensagem);
    } else {
      window.open(acess.urlMensagem);
    }
  }

  atualizarConsultorSelecionado() {
    const tab = this.$refs.tabIndex as TabIndex;
    tab.atualizarConsultorSelecionado();
  }

  atualizarPlano() {
    const tab = this.$refs.tabPlanos as TabPlanos;
    if (tab != undefined) {
      tab.atualizarPlano();
    }
  }
}
